import React from "react"
import {TITLE_DESIGN_SYSTEM_PAGE} from "../../../../utils/constants"
import SideBarLayout from "../../../layout/side-bar-layout"
import {Box, Paper, Stack, Typography} from "@mui/material"
import CodeViewer from "../../../components/CodeViewer/code-viewer"
import ButtonWithIcon from "../../../components/Button/Button"
import {dispatchSnackbar} from "../../../components/SnackBar/snackbar-bus"

const SnackbarPage = () => {
    const TITLE_PAGE = `${TITLE_DESIGN_SYSTEM_PAGE} | Snackbar`

    const returnStringButton = (message, variant) => {
        return `import { dispatchSnackbar } from "../../components/SnackBar/snackbar-bus"
dispatchSnackbar("${message}", "${variant}")`
    }

    const codeBasicUsage = `import { dispatchSnackbar } from "../../components/SnackBar/snackbar-bus"

dispatchSnackbar("Sucesso na requisição!", "success")`

    const codeUsageInContext = `service
  .loadCadastros(cetip, versao)
  .then((response) => {
    // trata resposta com sucesso
  })
  .catch(() => {
    dispatchSnackbar("Erro ao carregar os registros!", "error")
  })`

    const buttonsVariants = [
        {message: "Sucesso na requisição", variant: "success"},
        {message: "Falha ao processar a requisição.", variant: "error"},
        {message: "Atenção: verifique os dados informados.", variant: "warning"},
    ]

    const buttonCallSnack = (message, variant) => <div>
        <Box mb={1}>
            <ButtonWithIcon
                sx={{alignSelf: "flex-start", width: "auto"}}
                variant="contained"
                onClick={() => dispatchSnackbar(message, variant)}
            >
                {variant}
            </ButtonWithIcon>
        </Box>
        <CodeViewer code={returnStringButton(message, variant)} language="tsx"/>
        <br/>
    </div>

    return (
        <SideBarLayout
            header
            title={TITLE_PAGE}
            headerTitle={TITLE_PAGE}
        >
            <Box sx={{mt: -2}}>
                <Stack spacing={3}>

                    {/* INTRO */}
                    <Paper>
                        <Box p={3}>
                            <Typography variant="h4" gutterBottom color="common.white">
                                {`Snackbar`}
                            </Typography>

                            <Typography variant="body2" color="text.secondary" paragraph>
                                {`O Snackbar é o componente responsável por exibir mensagens de feedback rápidas para o usuário,
como confirmações de sucesso, avisos ou erros decorrentes de ações realizadas na interface.`}
                            </Typography>

                            <Typography variant="body2" color="text.secondary">
                                {`Na C2P, o Snackbar é disparado de forma global através de um event bus (snackbar-bus),
permitindo que qualquer parte da aplicação acione uma mensagem sem precisar conhecer diretamente
a estrutura visual do componente.`}
                            </Typography>
                        </Box>
                    </Paper>

                    {/* CHAMADA BÁSICA */}
                    <Paper>
                        <Box p={3}>
                            <Typography variant="h6" gutterBottom color="common.white">
                                {`Disparando o Snackbar via dispatchSnackbar`}
                            </Typography>

                            <Typography variant="body2" color="text.secondary" paragraph>
                                {`Para exibir uma mensagem, basta importar a função `}
                                <code>dispatchSnackbar</code>
                                {` e chamá-la com a mensagem e o tipo (variant) desejado.
O listener que está embutido no layout (AlertListener dentro do SideBarLayout) escuta esse evento
e renderiza o Snackbar na tela.`}
                            </Typography>

                            <CodeViewer code={codeBasicUsage} language="tsx"/>
                        </Box>
                    </Paper>

                    {/* EXEMPLOS INTERATIVOS DE VARIANTS */}
                    <Paper>
                        <Box p={3}>
                            <Typography variant="h6" gutterBottom color="common.white">
                                {`Exemplos de variants`}
                            </Typography>

                            <Typography variant="body2" color="text.secondary" paragraph>
                                {`Abaixo alguns exemplos de disparo do Snackbar com as três variações disponíveis: success, error e warning.`}
                            </Typography>

                            <br/>
                            <Stack direction="column" spacing={2}>
                                {
                                    buttonsVariants.map((item) => (
                                        buttonCallSnack(item.message, item.variant)
                                    ))
                                }
                            </Stack>
                        </Box>
                    </Paper>

                    {/* EXEMPLO EM CÓDIGO REAL */}
                    <Paper>
                        <Box p={3}>
                            <Typography variant="h6" gutterBottom color="common.white">
                                {`Exemplo de uso em chamadas de serviço`}
                            </Typography>

                            <Typography variant="body2" color="text.secondary" paragraph>
                                {`Um caso comum é exibir mensagens de erro ou sucesso após chamadas a serviços.
No exemplo abaixo, o Snackbar é disparado dentro do bloco de erro da requisição:`}
                            </Typography>

                            <CodeViewer code={codeUsageInContext} language="tsx"/>
                        </Box>
                    </Paper>

                </Stack>
            </Box>
        </SideBarLayout>
    )
}

export default SnackbarPage